import { Outlet } from "react-router-dom";

const CitasWrapper: React.FC = () => {
    return <Outlet />;
};

export default CitasWrapper;
